import React, { useRef, useState, useEffect } from 'react';
import { Form, Button, Card, Alert, Container} from 'react-bootstrap';
import { useAuth } from '../Context/AuthContext';
import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { toast } from 'react-toastify';

import logo from '../Assets/logo.png';


export default function ClientLogin(){
    const emailRef = useRef();
    const passwordRef = useRef();
    const [error, setError] = useState('');
    const [error2, setError2] = useState('');
    const [loading, setLoading] = useState(false);
    const { login, currentUser } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    let { from } = location.state || { from: { pathname: "/client-login" } }
    useEffect(()=>{
        if((from.pathname === '/client') && !currentUser?.client){
            setError('You do not have access to the Client Portal, please contact The Proven Group');
        }else{
            setError('');
        }
        return () =>{ setLoading(false) }
    }, [from, currentUser]);

    async function handleSubmit(event){
        event.preventDefault();
        if(emailRef.current.value === null || emailRef.current.value === ''){
            // toast.error('Email must be filled out', {
            //     style: {backgroundColor:'var(--error)'}
            // });
            return setError2('Email must be filled out');
        }
        if(passwordRef.current.value === null || passwordRef.current.value === ''){
            // toast.error('Password must be filled out', {
            //     style: {backgroundColor:'var(--error)'}
            // });
            return setError2('Password must be filled out');
        }
        try{
            setError('');
            setError2('');
            setLoading(true);
            const result = await login(emailRef.current.value, passwordRef.current.value); 
            if(result === true){
                navigate("/client");
            }else{
                setError2('Failed to login: ' + result);
            }
            
        } catch(error){
            // toast.error(`Faile to log in: ${error.message}`, {
            //     style: {backgroundColor:'var(--error)'}
            // });
            setError2('Failed to log in: ' + error.message);
        }

        setLoading(false);
    }

    return (
        <>
            <Container className="d-flex align-items-center justify-content-center mt-5" style={{minHeight: "60vh"}}>
                <div className="w-100" style={{maxWidth: "600px"}}>
                    <Card>
                        <Card.Img variant="top" src={logo} style={{width:"50%", alignSelf:"center", paddingTop:"20px"}}/>
                        <Card.Body>
                            <h2 className="text-center mb-4">Client Log in</h2>
                            {error && <Alert variant="danger">{error}</Alert>}
                            {error2 && <Alert variant="danger">{error2}</Alert>}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group id="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" ref={emailRef} required />
                                </Form.Group>
                                <Form.Group id="password">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control type="password" ref={passwordRef} required />
                                </Form.Group>
                                <Button disabled={loading} className="w-100 btn-dark" style={{marginTop: "15px", backgroundColor:"#2596be"}} type="submit" onClick={handleSubmit}>Log in</Button>
                            </Form>
                            <div className="w-100 text-center mt-3">
                                <Link to="/client-forgot-password">Forgot Password?</Link>
                            </div>
                        </Card.Body>
                    </Card>
                    <div className="w-100 text-center mt-2">
                        Need an account? <Link to="/client-signup">Sign up</Link>
                    </div>
                </div>
            </Container>
        </>
    )
}
